import { render, staticRenderFns } from "./SortDetailModal.vue?vue&type=template&id=3ade40f2&scoped=true"
import script from "./SortDetailModal.vue?vue&type=script&lang=js"
export * from "./SortDetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ade40f2",
  null
  
)

export default component.exports